import {
	pipelineFilters,
	SuplierPipelinefilters,
} from '../components/QuotesTable/config/pipelineFilters/pipelineFilters';
import { DEFAULT_SORTER, GLOBAL_DEBOUNCE_TIME, ROLE_TYPES } from '../utils/DataConstants';
import {
	quotesClientRestCrudThunks,
	quotesSubcontractorRestCrudThunks,
	quotesRestCrudThunksForBuyer,
	updateQuoteStatusBulk,
} from './quotes_thunks';
import { QUOTES_CRUD_ACTION_CREATORS } from '../actions/quotes_actions';
import { isClientQuoteViewLocation } from '../components/quote_utils/QuoteUtils';

const queryString = require('qs');
const defaultPagination = { current: 1, pageSize: 10 };
const debounce = require('debounce-promise');

const getQuoteRestCrudThunks = (userType, history) =>
	userType === ROLE_TYPES.SUPPLIER
		? isClientQuoteViewLocation(history.location)
			? quotesClientRestCrudThunks
			: quotesSubcontractorRestCrudThunks
		: quotesRestCrudThunksForBuyer;

const parseURL = (
	handleQueryParams,
	history,
	location,
	preAppliedFilters,
	initialPagination,
	initialSorting,
	initialFilters = {},
	initialSelections = []
) => {
	let pagination = initialPagination || defaultPagination;
	let sorting = initialSorting || DEFAULT_SORTER;
	let filters = { ...preAppliedFilters, ...initialFilters };
	let selections = initialSelections;
	if (handleQueryParams && location) {
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);

		const {
			current = pagination.current,
			pageSize = pagination.pageSize,
			sort_by = sorting.sort_by,
			order = sorting.order,
			...workOrderFilters
		} = queryParams;

		pagination = { current: parseInt(current), pageSize: parseInt(pageSize) };
		sorting = { sort_by, order };
		filters = {
			...(workOrderFilters || {}),
			...preAppliedFilters,
		};
	}
	return { pagination, sorting, filters, selections };
};
export const fetchQuotes =
	(userType) =>
	(
		handleQueryParams,
		history,
		location,
		targetCollectionName,
		preAppliedFilters = {},
		initialPagination,
		initialSorting,
		initialFilters,
		ignoreRefreshCounts
	) =>
	(dispatch, getState) => {
		const { pagination, sorting, filters } = parseURL(
			handleQueryParams,
			history,
			location,
			preAppliedFilters,
			initialPagination,
			initialSorting,
			initialFilters
		);
		dispatch(updateSelection(userType)(false, history, targetCollectionName, []));
		dispatch(
			fetchData(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				ignoreRefreshCounts
			)
		);
	};

export const updatePaginationQuotes =
	(userType) =>
	(handleQueryParams, history, targetCollectionName, pagination, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { sorting, filters } = getState().proposals[targetCollectionName];
		return dispatch(
			fetchData(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				ignoreRefreshCounts
			)
		);
	};

export const updateFiltersQuotes =
	(userType) =>
	(handleQueryParams, history, targetCollectionName, filters, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const {
			sorting,
			filters: storeFilters,
			pagination,
		} = getState().proposals[targetCollectionName];
		dispatch(
			fetchData(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				sorting,
				{
					...storeFilters,
					...filters,
				},
				ignoreRefreshCounts
			)
		);
	};

export const replaceFiltersAndSortingQuotes =
	(userType) =>
	(handleQueryParams, history, targetCollectionName, filters, sorting, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { pagination } = getState().proposals[targetCollectionName];
		dispatch(
			fetchData(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				sorting,
				filters,
				ignoreRefreshCounts
			)
		);
	};

export const clearFiltersQuotes =
	(userType) =>
	(handleQueryParams, history, targetCollectionName, preAppliedFilters, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { pagination } = getState().proposals[targetCollectionName];
		dispatch(
			fetchData(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				{ ...DEFAULT_SORTER },
				{
					...preAppliedFilters,
				},
				ignoreRefreshCounts
			)
		);
	};

export const updateSortingQuotes =
	(userType) =>
	(handleQueryParams, history, targetCollectionName, sorting, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { filters, pagination } = getState().proposals[targetCollectionName];
		dispatch(
			fetchData(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				sorting,
				filters,
				ignoreRefreshCounts
			)
		);
	};
export const refreshCounts =
	(userType, history) => (targetCollectionName, filters) => (dispatch, getState) => {
		const finalPipelineFilters =
			userType === ROLE_TYPES.SUPPLIER ? SuplierPipelinefilters : pipelineFilters;
		finalPipelineFilters.forEach((pf) => {
			dispatch(
				getQuoteRestCrudThunks(userType, history).countBy(
					{
						...filters,
						statuses: undefined,
						status: undefined,
						...pf.filter,
					},
					pf.name
				)
			);
		});
	};

const fetchDataFromServer = (props) => {
	const {
		dispatch,
		userType,
		addtionalParams,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		ignoreRefreshCounts,
		history,
	} = props;
	!ignoreRefreshCounts && dispatch(refreshCounts(userType, history)(targetCollectionName, filters));
	return dispatch(
		getQuoteRestCrudThunks(userType, history).read(
			addtionalParams,
			targetCollectionName,
			pagination,
			sorting,
			filters
		)
	);
};

const debouncedFetchData = debounce(fetchDataFromServer, GLOBAL_DEBOUNCE_TIME);

const fetchData =
	(userType) =>
	(
		handleQueryParams,
		history,
		addtionalParams,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		ignoreRefreshCounts
	) =>
	(dispatch) => {
		const props = {
			dispatch,
			history,
			userType,
			addtionalParams,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			ignoreRefreshCounts,
		};
		if (handleQueryParams) {
			const queryParams = queryString.stringify({
				...{
					current: pagination.current,
					pageSize: pagination.pageSize,
				},
				...sorting,
				...filters,
				...addtionalParams,
			});
			history.replace(`${window.location.pathname}?${queryParams}`);
		}
		if (targetCollectionName && targetCollectionName.includes('_widget_')) {
			return fetchDataFromServer(props);
		} else {
			dispatch(QUOTES_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollectionName));
			dispatch(QUOTES_CRUD_ACTION_CREATORS.updatePagination(pagination, targetCollectionName));
			return debouncedFetchData(props);
		}
	};
export const updateSelection =
	(userType) =>
	(handleQueryParams, history, targetCollectionName, selections) =>
	(dispatch, getState) => {
		return dispatch(QUOTES_CRUD_ACTION_CREATORS.updateSelections(selections, targetCollectionName));
	};

export const updateQuoteStatusBulkWrapper =
	(roleType) => (ids, status, targetCollectionName, quoteParams) => (dispatch, getState) => {
		const { sorting, pagination, history, filters } = getState().proposals[targetCollectionName];
		return new Promise((resolve, reject) => {
			dispatch(updateQuoteStatusBulk(roleType)(ids, status))
				.then((data) => {
					if (data.status !== 'error') {
						let ents = data.map((d) => {
							let record = {};
							quoteParams.map((param) => (record[param] = d[param]));
							record['id'] = record['id'].toString();
							return record;
						});
						dispatch(updateSelection(roleType)(false, history, targetCollectionName, ents));
						dispatch(
							fetchData(roleType)(
								false,
								history,
								{},
								targetCollectionName,
								pagination,
								sorting,
								filters,
								false
							)
						);
						resolve(data); //Async with fetch
					} else {
						reject(data);
					}
				})
				.catch((error) => reject(error));
		});
	};
